/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../common/sort';
import '../resources/enums';
import '../resources/datatypes';
import '../../resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "SearchCatalogItemsRequest": {
                        "fields": {
                          "textFilter": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "categoryIds": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "stockLevels": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.SearchCatalogItemsRequest.StockLevel",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "enabledLocationIds": {
                            "type": "string",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "vendorIds": {
                            "type": "string",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "cursor": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "limit": {
                            "type": "int32",
                            "id": 7,
                            "rule": "optional"
                          },
                          "sortOrder": {
                            "type": ".squareup.connect.v2.common.SortOrder",
                            "id": 8,
                            "rule": "optional",
                            "options": {
                              "default": "ASC"
                            }
                          },
                          "productTypes": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogItemProductType",
                            "id": 9,
                            "rule": "repeated"
                          },
                          "nullFieldFilters": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.SearchCatalogItemsRequest.NullableField",
                            "id": 10,
                            "rule": "repeated"
                          },
                          "hasVendorCode": {
                            "type": "bool",
                            "id": 11,
                            "rule": "optional"
                          },
                          "customAttributeFilters": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.CustomAttributeFilter",
                            "id": 13,
                            "rule": "repeated"
                          },
                          "soldOut": {
                            "type": "bool",
                            "id": 14,
                            "rule": "optional"
                          },
                          "includeNestedObjects": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.InlineTypes",
                            "id": 15,
                            "rule": "optional",
                            "options": {
                              "default": "INLINE_ALL"
                            }
                          },
                          "stockableFilter": {
                            "type": "bool",
                            "id": 16,
                            "rule": "optional"
                          },
                          "ecomVisibilities": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.EcomVisibility",
                            "id": 17,
                            "rule": "repeated"
                          },
                          "excludeProductTypes": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogItemProductType",
                            "id": 18,
                            "rule": "repeated"
                          },
                          "archivedState": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.ArchivedState",
                            "id": 19,
                            "rule": "optional",
                            "options": {
                              "default": "ARCHIVED_STATE_NOT_ARCHIVED"
                            }
                          },
                          "channels": {
                            "type": "string",
                            "id": 20,
                            "rule": "repeated"
                          },
                          "hasSalePrice": {
                            "type": "bool",
                            "id": 21,
                            "rule": "optional"
                          },
                          "stockQuantity": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.Range",
                            "id": 22,
                            "rule": "optional"
                          },
                          "itemIds": {
                            "type": "string",
                            "id": 23,
                            "rule": "repeated"
                          },
                          "excludeItemIds": {
                            "type": "string",
                            "id": 24,
                            "rule": "repeated"
                          },
                          "includeApproximateCount": {
                            "type": "bool",
                            "id": 25,
                            "rule": "optional"
                          },
                          "includeApproximateCountLimit": {
                            "type": "int64",
                            "id": 26,
                            "rule": "optional",
                            "options": {
                              "default": 3000
                            }
                          },
                          "itemVariationCount": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.Range",
                            "id": 27,
                            "rule": "optional"
                          },
                          "textSearchFilter": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.MultiFieldTextFilter",
                            "id": 28,
                            "rule": "repeated"
                          },
                          "sellable": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.SellableValue",
                            "id": 29,
                            "rule": "optional"
                          },
                          "stockable": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.StockableValue",
                            "id": 30,
                            "rule": "optional"
                          },
                          "enabledFulfillmentMethodsFilter": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.SearchCatalogItemsRequest.EnabledFulfillmentMethodsFilter",
                            "id": 31,
                            "rule": "optional"
                          },
                          "isAlcoholic": {
                            "type": "bool",
                            "id": 32,
                            "rule": "optional"
                          },
                          "includeInventory": {
                            "type": "bool",
                            "id": 33,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "programEligibilities": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.ProgramEligibility",
                            "id": 34,
                            "rule": "repeated"
                          },
                          "includeOptions": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.IncludeOptions",
                            "id": 35,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "NullableField": {
                            "values": {
                              "VENDOR_ID": 1,
                              "SKU": 2,
                              "CATEGORY_ID": 3,
                              "REGULAR_CATEGORY_ID": 4,
                              "FULFILLMENT_METHODS": 5
                            }
                          },
                          "StockLevel": {
                            "values": {
                              "STOCK_LEVEL_DO_NOT_USE": 0,
                              "OUT": 1,
                              "LOW": 2
                            }
                          },
                          "EnabledFulfillmentMethod": {
                            "values": {
                              "ENABLED_FULFILLMENT_METHOD_DO_NOT_USE": 0,
                              "PICKUP": 1,
                              "DELIVERY": 2,
                              "DINE_IN": 3,
                              "SHIPPING": 4
                            }
                          },
                          "FilterType": {
                            "values": {
                              "FILTER_TYPE_DO_NOT_USE": 0,
                              "MATCH_ALL": 1,
                              "MATCH_ANY": 2
                            }
                          },
                          "EnabledFulfillmentMethodsFilter": {
                            "fields": {
                              "enabledFulfillmentMethods": {
                                "type": ".squareup.connect.v2.merchant_catalog.service.SearchCatalogItemsRequest.EnabledFulfillmentMethod",
                                "id": 1,
                                "rule": "repeated"
                              },
                              "filterType": {
                                "type": ".squareup.connect.v2.merchant_catalog.service.SearchCatalogItemsRequest.FilterType",
                                "id": 2,
                                "rule": "optional",
                                "options": {
                                  "default": "MATCH_ALL"
                                }
                              }
                            }
                          }
                        }
                      },
                      "CustomAttributeFilter": {
                        "fields": {
                          "customAttributeDefinitionId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "key": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "stringFilter": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "numberFilter": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.Range",
                            "id": 4,
                            "rule": "optional"
                          },
                          "selectionUidsFilter": {
                            "type": "string",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "boolFilter": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional"
                          },
                          "existsFilter": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional"
                          },
                          "boolExistFilter": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.CustomAttributeFilter.BoolExistFilter",
                            "id": 8,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "BoolExistFilter": {
                            "fields": {
                              "value": {
                                "type": "bool",
                                "id": 1,
                                "rule": "optional"
                              },
                              "matchItemsWithoutAttribute": {
                                "type": "bool",
                                "id": 2,
                                "rule": "optional",
                                "options": {
                                  "default": false
                                }
                              },
                              "matchVariationsWithoutAttribute": {
                                "type": "bool",
                                "id": 3,
                                "rule": "optional",
                                "options": {
                                  "default": false
                                }
                              }
                            }
                          }
                        }
                      },
                      "Range": {
                        "fields": {
                          "min": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "max": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "SearchCatalogItemsResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "items": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "cursor": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "matchedVariationIds": {
                            "type": "string",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "approximateCount": {
                            "type": "int64",
                            "id": 5,
                            "rule": "optional"
                          },
                          "includedResources": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.IncludedResources",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogItemsRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogItemsRequest?.nested?.NullableField && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogItemsRequest?.nested?.StockLevel && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogItemsRequest?.nested?.EnabledFulfillmentMethod && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogItemsRequest?.nested?.FilterType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogItemsRequest?.nested?.EnabledFulfillmentMethodsFilter && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CustomAttributeFilter && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CustomAttributeFilter?.nested?.BoolExistFilter && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.Range && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogItemsResponse) {
  $root.addJSON(jsonData);
}

/**
 * @desc Defines the request body for the [SearchCatalogItems](api-endpoint:Catalog-SearchCatalogItems) endpoint.
 *
 * SOURCE SearchCatalogItemsRequest @ squareup/connect/v2/catalog/interfaces/search-catalog-items.proto at 23:1
 */
export const SearchCatalogItemsRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SearchCatalogItemsRequest');
fixType(SearchCatalogItemsRequest);
Builder.createAndAttachToType(SearchCatalogItemsRequest);
/**
 * @desc Supported nullable attributes that can be used in a query expression to
 * return items or item variations when a nullable attribute value on the items
 * or item variations matches the associated query expression or when the nullable
 * attribute is not assigned to the items or item variations.
 *
 * SOURCE NullableField @ squareup/connect/v2/catalog/interfaces/search-catalog-items.proto at 32:3
 */
SearchCatalogItemsRequest.NullableField = $root.lookupEnum('squareup.connect.v2.merchant_catalog.service.SearchCatalogItemsRequest.NullableField').values;
/**
 * @desc Defines supported stock levels of the item inventory.
 *
 * SOURCE StockLevel @ squareup/connect/v2/catalog/interfaces/search-catalog-items.proto at 47:3
 */
SearchCatalogItemsRequest.StockLevel = $root.lookupEnum('squareup.connect.v2.merchant_catalog.service.SearchCatalogItemsRequest.StockLevel').values;
/**
 * @desc Defines the fulfillment type that an item is enabled for
 *
 * SOURCE EnabledFulfillmentMethod @ squareup/connect/v2/catalog/interfaces/search-catalog-items.proto at 128:3
 */
SearchCatalogItemsRequest.EnabledFulfillmentMethod = $root.lookupEnum('squareup.connect.v2.merchant_catalog.service.SearchCatalogItemsRequest.EnabledFulfillmentMethod').values;
/**
 * --
 * @desc Defines the type of filtering to do on the fulfillment methods.
 * If set to NONE, return items with no fulfillment methods enabled.
 * --
 *
 * SOURCE FilterType @ squareup/connect/v2/catalog/interfaces/search-catalog-items.proto at 141:3
 */
SearchCatalogItemsRequest.FilterType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.service.SearchCatalogItemsRequest.FilterType').values;
/**
 * SOURCE EnabledFulfillmentMethodsFilter @ squareup/connect/v2/catalog/interfaces/search-catalog-items.proto at 148:3
 */
SearchCatalogItemsRequest.EnabledFulfillmentMethodsFilter = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SearchCatalogItemsRequest.EnabledFulfillmentMethodsFilter');
fixType(SearchCatalogItemsRequest.EnabledFulfillmentMethodsFilter);
Builder.createAndAttachToType(SearchCatalogItemsRequest.EnabledFulfillmentMethodsFilter);
/**
 * --
 * @desc Supported custom attribute query expressions for calling the
 * [SearchCatalogItems](api-endpoint:Catalog-SearchCatalogItems)
 * endpoint to search for items or item variations.
 * --
 *
 * SOURCE CustomAttributeFilter @ squareup/connect/v2/catalog/interfaces/search-catalog-items.proto at 182:1
 */
export const CustomAttributeFilter = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CustomAttributeFilter');
fixType(CustomAttributeFilter);
Builder.createAndAttachToType(CustomAttributeFilter);
/**
 * SOURCE BoolExistFilter @ squareup/connect/v2/catalog/interfaces/search-catalog-items.proto at 213:3
 */
CustomAttributeFilter.BoolExistFilter = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CustomAttributeFilter.BoolExistFilter');
fixType(CustomAttributeFilter.BoolExistFilter);
Builder.createAndAttachToType(CustomAttributeFilter.BoolExistFilter);
/**
 * --
 * @desc The range of a number value between the specified lower and upper bounds.
 * --
 *
 * SOURCE Range @ squareup/connect/v2/catalog/interfaces/search-catalog-items.proto at 232:1
 */
export const Range = $root.lookupType('squareup.connect.v2.merchant_catalog.service.Range');
fixType(Range);
Builder.createAndAttachToType(Range);
/**
 * --
 * @desc Defines the response body returned from the [SearchCatalogItems](api-endpoint:Catalog-SearchCatalogItems) endpoint.
 * --
 *
 * SOURCE SearchCatalogItemsResponse @ squareup/connect/v2/catalog/interfaces/search-catalog-items.proto at 246:1
 */
export const SearchCatalogItemsResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SearchCatalogItemsResponse');
fixType(SearchCatalogItemsResponse);
Builder.createAndAttachToType(SearchCatalogItemsResponse);